import * as React from "react";
const SvgEMobiledata = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 9V7H8v10h8v-2h-6v-2h6v-2h-6V9h6z",
  fill: "currentColor"
}));
export default SvgEMobiledata;